<template>
  <!--MENU-->
  <header 
    style="height: 60px;"
    v-if="$route.meta.showHeader"
    class="page d-flex align-items-center px-3">
    <a 
      href="https://parkiduo.com">
      <img 
        style="height: 50px;"
        :src="logo"/>
    </a>
  </header>
  <!--FIN MENU-->
  <!--PAGE DEL USER Y CAMARERO-->
  <router-view
    v-if="!$route.meta.fullpage"
    class="page"
    :style="{top: $route.meta.showHeader ? '60px' : '0'}"
  />
  <router-view
    v-else
    class="page"
    :style="{top: $route.meta.showHeader ? '60px' : '0'}"
  />
  <!--MENU DEL USER-->
  <footer v-if="$route.meta.showFooter">
    <div class="row m-0 pt-3">
      <router-link
        to="/Home"
        class="col-3 text-decoration-none"
      >
        <i class="fa-solid fa-utensils fs-3 w-100 text-center text-nav" />
        <p class="button-text text-center text-nav">
          Carta
        </p>
      </router-link>
      <router-link
        to="/Carrito"
        class="col-3 text-decoration-none pe-4 carrito"
      >
        <span class="amount-carrito px-2">{{ carrito }}</span>
        <i class="fa-solid fa-basket-shopping fs-3 w-100 text-center text-nav" />
        <p class="button-text text-center mb-0 text-nav">
          Carrito
        </p>
      </router-link>
      <router-link
        to="/MisPedidos"
        class="col-3 text-decoration-none ps-4"
      >
        <i class="fas fa-rectangle-list fs-3 w-100 text-center text-nav" />
        <p class="button-text text-center mb-0 text-nav">
          Pedidos
        </p>
      </router-link>
      <router-link
        to="/Cuenta"
        class="col-3 text-decoration-none"
      >
        <i class="fas fa-receipt fs-3 w-100 text-center text-nav" />
        <p class="button-text text-center mb-0 text-nav">
          Cuenta
        </p>
      </router-link>
    </div>
  </footer>
  <!--FIN MENU DEL USER-->
</template>

<script>
  import { mapState } from 'vuex';
  //import axios from 'axios';
  //import router from '@/router';
  import logo from '@/assets/newLogo.png'; // El @ apunta a /src
  import mixpanel from 'mixpanel-browser';

  export default {
    name: 'App',
    components: {
    },
    data() {
      return {
        loginsFallidos: 0,
        isSidebarVisible: true,
        logo
      }
    },
    computed:{
        ...mapState(['isLoggedIn']),
        ...mapState(['token']),
        ...mapState(['refresh']),
    },
    mounted() {
      // Inicializa Mixpanel con tu token (lo consigues en tu panel de Mixpanel)
      const isProd = process.env.VUE_APP_ENV === 'production';
      mixpanel.init('7c4d18c531e387670c1bf09cf498cdb3', {
        debug: !isProd,
        track_pageview: true,
      });
    },
    created() {
      if (window.innerWidth <= 768) {
        this.isSidebarVisible = false;
      }
      },
      beforeUnmount() {
        this.stopPolling();
      },
    methods:{
      logout() {
        this.$store.commit('logout');
      },
      toggleSidebar() {
        this.isSidebarVisible = !this.isSidebarVisible;
        document.body.classList.toggle('no-scroll', this.isSidebarVisible);
      }
    },
  };
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@400;500;600;700;800;900&family=Poppins:wght@400;500;600;800;900&display=swap');

  * {
    font-family: 'Urbanist', sans-serif;
    
  }
  body{
    background-color: #f5f5f5 !important;
  }

  .text-nav{
    color:#F47700;
  }

  footer{
    position: fixed;
    bottom: 0;
    width: 100vw; 
    height: 80px;
    
    z-index: 10;
    background-color: transparent;
  }

  .footer-rounded{
    position: fixed;
    z-index: 0;
    bottom: 0;
    width: 100vw; 
    height: 80px;
  }

  .page {
    position: fixed;
    height: calc(100% - 60px);
    top: 0;
    overflow-y: auto; /* Mejor para scroll */
    background-color: rgb(243, 243, 243) !important;
    
    /* ANCHO RESPONSIVO */
    width: 100%; /* Por defecto ocupa todo en móvil */
    max-width: 400px; /* Define el ancho como un móvil en PC */
    left: 50%; /* Centra horizontalmente */
    transform: translateX(-50%); /* Ajuste fino para centrar */
    
    /* SOMBRA Y BORDES OPCIONALES */
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

/* Para evitar que esto afecte móviles */
@media (max-width: 768px) {
    .page {
        max-width: 100%; /* En móvil sigue ocupando todo */
        border: none;
        box-shadow: none;
    }
}
  

  nav,
    .offcanvas {
      background-color: #1e293b;
    }
    .navbar-toggler {
      border: none;
    }
    .navbar-toggler:focus {
      outline: none;
      box-shadow: none;
    }

    .selected{
      color: #F47700 !important;
      background-color: white;
    }

    .no-link-style {
      text-decoration: none;
      color: inherit;
      cursor: pointer;
    }

    .no-scroll {
      overflow: hidden;
    }

    @media (min-width: 1200px) {
      .phone-icon{
        left: 47%;
        height: 50px;
        width: 6%;
      }
    }

    @media (min-width: 767px) {
      .phone-icon{
        left: 46%;
        height: 50px;
        width: 8%;
      }
      
    }

    @media (max-width: 1170px) {
      #left-menu {
        width: 25%;
        transition: 3s !important;
      }
    }

    @media (max-width: 768px) {

      #left-menu {
        width: 50%;
        transition: 3s !important;
      }

      .powered{
        top: 10px;
        right: 10px;
      }
    }

    @media (max-width: 576px) {

    }

    @media (max-width: 400px) {

    }

    .custom-scroll {
      padding-top: 10px;
    }

    .custom-scroll::-webkit-scrollbar {
      width: 7px;
    }

    .custom-scroll::-webkit-scrollbar-thumb {
      background-color: #011638;
      border-radius: 10px;
    }
</style>